// User roles and reputation thresholds
export const KeyAdmin = 1;
export const KeyUser = 0;
export const KeyReputationEditor = 100;
export const KeyReputationContributor = 50;
export const KeyReputationDeleter = 200;
